export default __webpack_public_path__ + "cf4a0875f0d86f45926295249ad48ac4.png";